import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const InfoCardContainer = styled.div<{ theme: { token: GlobalToken } }>`
  .info-card {
    width: 100%;
    height: 100%;
    border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
  }

  .info-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${({ theme: { token } }) => token.padding}px;
    border: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
    border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px
      ${({ theme: { token } }) => token.borderRadiusLG}px 0 0;
  }

  .info-card-title-wrapper {
    display: flex;
    align-items: center;
    gap: ${({ theme: { token } }) => token.marginXS}px;
  }

  .info-card-title {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }

  .edit-button {
    color: ${({ theme: { token } }) => token.colorPrimary};
  }

  .icon-avatar {
    background-color: ${({ theme: { token } }) => token.colorPrimaryBg};
    color: ${({ theme: { token } }) => token.colorPrimary};
  }

  .info-card-content {
    padding: ${({ theme: { token } }) => token.padding}px ${({ theme: { token } }) => token.paddingXL}px;
    border: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
    border-top: none;
    border-radius: 0 0 ${({ theme: { token } }) => token.borderRadiusLG}px
      ${({ theme: { token } }) => token.borderRadiusLG}px;
    height: 5.5rem;
    overflow: hidden;
  }
`;
